module.exports = __webpack_public_path__ + "img/nhdl-top-banner.702376a2.jpg";